export const showUp = (viewport, showAll, currentNewsFiltered) => {
  return (
    (viewport === 'mobile' && showAll) ||
    (viewport === 'tablet' && currentNewsFiltered.length > 4) ||
    (viewport === 'desktop' && currentNewsFiltered.length > 3)
  );
};
